/**
 * Where the run's page banner renders, as one predicate.
 *
 * Both Design Studio pages carry `BrandRunPageBanner` above their masthead, so
 * the app-wide snackbar has to stand down on both of them — otherwise the Files
 * page announces the same run twice. The snackbar host and the banner's own
 * navigation target read this file so the two can never disagree.
 */

/** TanStack route id for the Styles page, where the wizard acts on a run. */
export const STYLES_ROUTE = '/workspaces/$workspaceId/design-studio/global-styles';

const BANNER_PATH = /^\/workspaces\/\d+\/design-studio\/(global-styles|dashboard)(\/|$)/;

/** Whether this path is a Design Studio page that renders the run banner itself. */
export function isBrandRunBannerRoute(pathname: string): boolean {
  return BANNER_PATH.test(pathname);
}
